export enum ValidateVoucherResultEnum {
    Expired = 0,
    NotEnoughMoney = 1,
    CoverEntireAmount = 2,
    CannotBeAppliedForClassOfService = 3,
    PartialPayment = 4,
    Error = 5,
    CancelAppliedVoucher = 6
}
